export enum EDashboardTab {
  Dashboard,
  Welcome,
}
